import { useStaticQuery, graphql } from 'gatsby'

export const useTestimonialsSectionQuery = () => {
  const { wpPage, forRatingValuePart1, forRatingValuePart2, reviews } = useStaticQuery(graphql`
    query TestimonialsSectionQuery {
      wpPage(title: { eq: "Home" }) {
        testimonialsSection {
          testimonialsSection {
            videoSection {
              title
              mobileImage {
                sourceUrl
              }
              desktopImage {
                sourceUrl
              }
              playButton {
                localFile {
                  publicURL
                }
              }
              videoUrl {
                url
              }
              title2
              text
              link {
                url
              }
            }
            testimonials {
              title
              subtitle
              reviewWidgetText
              reviewIcons {
                googleIcon {
                  sourceUrl
                  mediaDetails {
                    width
                    height
                  }
                }
                facebookIcon {
                  sourceUrl
                  mediaDetails {
                    width
                    height
                  }
                }
              }
              link {
                title
                url
              }
              decorativeSvg {
                localFile {
                  publicURL
                }
              }
              images {
                mobileImage {
                  sourceUrl
                  mediaDetails {
                    width
                    height
                  }
                }
                desktopImage {
                  sourceUrl
                  mediaDetails {
                    width
                    height
                  }
                }
                altText
              }
            }
          }
        }
      }
      forRatingValuePart1: allBirdeyedata(
        filter: {
          id: { ne: "dummy" }
          sourceType: { ne: "Direct Feedback" }
          reviewer: { firstName: {}, lastName: {} }
        }
      ) {
        nodes {
          rating
        }
      }
      forRatingValuePart2: allBirdeyedata(filter: { id: { ne: "dummy" }, rating: { ne: 0 } }) {
        nodes {
          rating
        }
      }
      reviews: allBirdeyedata(
        limit: 1
        filter: {
          rating: { eq: 5 }
          comments: { ne: null }
          reviewer: { firstName: { ne: "Melynda" } }
        }
      ) {
        nodes {
          comments
          reviewer {
            firstName
            lastName
          }
          sourceType
        }
      }
    }
  `)
  return { wpPage, forRatingValuePart1, forRatingValuePart2, reviews }
}
